<script>
    import {mount, onMount, unmount} from 'svelte'
    import PaginationNavigation from 'views/components/paginationNavigation/PaginationNavigation'
    import SidebarActivityNavigation from 'views/pages/activities/show/sidebars/activityNavigation/ActivityNavigation'
    import HeroButton from 'views/components/heroButton/HeroButton'
    import NavigationBarLinear from 'views/pages/activities/show/navigationBar/NavigationBarLinear.svelte'
    import TaskGroup from 'views/components/taskGroups/TaskGroup'
    import ScanSummary from 'views/pages/activities/show/types/scan/ScanSummary.svelte'

    const {
        model,
    } = $props()

    // svelte-ignore non_reactive_update
    let navigationBar

    let activeItemKey = $state(-1)
    let activeTaskGroupModel = $state(null)
    let activeTaskGroupView = $state(null)

    const isStudentExamMode = $derived(
        ACL.checkRole(ACL.roles.STUDENT) &&
        !model.get('show_answers') &&
        model.has('exam_session') &&
        model.get('exam_session').closed === null
    )

    const isStudentExamClosedMode = $derived(
        ACL.checkRole(ACL.roles.STUDENT) &&
        model.get('exam_session').closed
    )

    const isStudentReviewAnswersMode = $derived(
        isStudentExamClosedMode &&
        model.get('show_answers')
    )

    function createTaskGroupView(el) {
        if (activeTaskGroupModel) {
            activeTaskGroupView = new TaskGroup({
                model: activeTaskGroupModel,
            })
            el.append(activeTaskGroupView.el)
        } else if (activeTaskGroupView) {
            activeTaskGroupView.destroy()
        }
    }

    function attachPaginationNavigation(el) {
        const navigation = new PaginationNavigation({
            previousUrlOrCallback: navigationBar.toPreviousItem,
            previousLabel: window.i18n.gettext('Previous'),
            nextUrlOrCallback: navigationBar.toNextItem,
            nextLabel: window.i18n.gettext('Next'),
            isActivity: true,
            previousTheme: 'secondary',
            nextTheme: 'secondary',
        })
        el.append(navigation.el)
    }

    function showSidebarActivityNavigation(sidebarTitle = window.i18n.gettext('Index')) {
        Backbone.View.sidebar.showSidebar(
            new SidebarActivityNavigation({
                model,
                navigationBar,
            }),
            sidebarTitle,
            500
        )
    }

    function onCloseExam() {
        if (isStudentExamMode) {
            model.handInTest(() => {
                // After take in, reload the activity so that results are shown
                Backbone.history.loadUrl()
            })
        } else {
            navigationBar.setActiveItem(model.task_groups.size())
        }
    }

    onMount(() => {
        let sidebarNavigationHeaderButton
        let goToEndHeaderButton
        const setHeaderButtonVisibility = () => {
            sidebarNavigationHeaderButton?.$el.toggle(activeItemKey !== model.task_groups.size())
            goToEndHeaderButton?.$el.toggle(activeItemKey >= 0 && activeItemKey < model.task_groups.size())
        }

        Backbone.View.menubar.setPreferredSize('small')
        Backbone.View.header.clearButtons()
        Backbone.View.header.setTitle()
        Backbone.View.header.setCrumblepath(
            model.getAllCrumblepathModels(),
            'show'
        )

        // When students have a closed exam but no answers visible, they can only see their score
        if (isStudentExamClosedMode && !isStudentReviewAnswersMode) {
            return () => {
                Backbone.View.menubar.setPreferredSize()
            }
        }

        navigationBar = mount(
            NavigationBarLinear,
            {
                target: Backbone.View.layout.el,
                props: {
                    model,
                },
            }
        )
        navigationBar.activeItemKey.subscribe((value) => {
            activeItemKey = value
            activeTaskGroupModel = model.task_groups.findWhere({sequence: value})

            // Send previous time log (if present) and start time log for new task group.
            model.stopTimeLog()
            if (activeTaskGroupModel) {
                model.startTimeLog(activeTaskGroupModel)
            }

            // Scroll back to top of page after transitioning to a new page.
            jQuery(window).scrollTop(0)

            setHeaderButtonVisibility()
        })

        if (model.task_groups.length > 1) {
            const navigationPanelTitle = ACL.checkRole(ACL.roles.STUDENT) && model.tasks.length > 0 ?
                window.i18n.gettext('Progress') : window.i18n.gettext('Index')
            sidebarNavigationHeaderButton = Backbone.View.header.addButton(
                new HeroButton({
                    firstLine: navigationPanelTitle,
                    icon: 'orderedlist',
                    callback: () => {
                        showSidebarActivityNavigation(navigationPanelTitle)
                    }
                })
            )

            if (isStudentExamMode) {
                goToEndHeaderButton = Backbone.View.header.addButton(
                    new HeroButton({
                        firstLine: window.i18n.gettext('Go to end'),
                        icon: 'skip-next',
                        callback: () => {
                            navigationBar.setActiveItem(model.task_groups.size())
                        },
                    })
                )
            }

            if (isStudentExamMode) {
                Backbone.Model.user.once('close-exam-by-teacher', onCloseExam)
            }
        }

        setHeaderButtonVisibility()

        return () => {
            Backbone.Model.user.off('close-exam-by-teacher', onCloseExam)
            Backbone.View.menubar.setPreferredSize()
            unmount(navigationBar)
        }
    })
</script>

<div class="activity">
    <div class="activity-viewport">
        {#if activeItemKey === -1 || activeItemKey === model.task_groups.size()}
            <!-- show start or end page -->
            <section class="summary">
                <article>
                    <ScanSummary
                        isStart={activeItemKey === -1}
                        {model}
                        {isStudentExamMode}
                        {isStudentExamClosedMode}
                        {isStudentReviewAnswersMode}
                        {navigationBar}
                    ></ScanSummary>
                </article>
            </section>
        {:else if activeTaskGroupModel}
            <!-- show task group -->
            {#key activeItemKey}
                <div
                    class="task-group"
                    use:createTaskGroupView
                ></div>
            {/key}
        {/if}
    </div>
    {#if activeTaskGroupModel}
        <div class="center-panel" use:attachPaginationNavigation></div>
    {/if}
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.activity {
  width: 100%;
  height: 100%;
}

.summary {
  position: absolute;
  inset: 0;
  background-color: hsl(205, 60%, 44%);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  color: #fff;
}
.summary article {
  height: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}</style>
